import React from 'react';
import PropTypes from 'prop-types';

import AbstractFunnel from "@components/abstract_funnel";
import withLoader from '@components/common/with_loader_decorator';
import withHistory from '@components/common/with_history_decorator'
import withPhoneCollector from '@components/common/with_phone_collector_decorator'
import Authenticator from '@components/common/authenticator'

import FunnelStatePersistance from '@services/funnel_state_persistance'

class CarpetAndUpholsteryFunnel extends AbstractFunnel {
    static childContextTypes = {
        locationStrategy: PropTypes.string
    };

    componentDidMount() {
        if(this.props.initializeStateAndHistory){
            this.props.initializeStateAndHistory({ componentName: 'CarpetAndUpholsteryFunnel', currentState: this.state });
        }
        FunnelStatePersistance.loadPersistedStateIfNeeded(this);
    }

    serviceType = () => {
        return 'carpet_and_upholstery_cleaning';
    };

    availabilityPathString = () => {
        return 'carpet_and_upholstery_availability_path';
    };


    companiesForDatePath = () => {
        return PathHelper('companies_for_date_carpet_and_upholstery_requests_path');
    };

    attributesPath = () => {
        return PathHelper('attributes_carpet_and_upholstery_requests_path');
    };

    extraServiceTypes = () => {
        return ['bathroom_cleaning', 'oven_cleaning', 'car_upholstery_cleaning']
    };
}


CarpetAndUpholsteryFunnel = withLoader(CarpetAndUpholsteryFunnel);
CarpetAndUpholsteryFunnel = withPhoneCollector(CarpetAndUpholsteryFunnel);
CarpetAndUpholsteryFunnel = withHistory(CarpetAndUpholsteryFunnel);

class AuthenticatingCarpetAndUpholsteryFunnel extends React.Component {
    render() {
        return (
            <Authenticator status={this.props.componentProps.authenticationStatus}
                           omniauthError={this.props.componentProps.omniauthError}
                           component={CarpetAndUpholsteryFunnel}
                           {...this.props} />
        );
    }
}

export default AuthenticatingCarpetAndUpholsteryFunnel;
